import { render } from "./ds-npot-view.vue?vue&type=template&id=3daa99b0&scoped=true"
import script from "./ds-npot-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ds-npot-view.vue?vue&type=script&setup=true&lang=js"

import "./ds-npot-view.vue?vue&type=style&index=0&id=3daa99b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3daa99b0"],['__file',"src/views/tep/tep-nsi/ds-npot-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3daa99b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3daa99b0', __exports__)) {
    api.reload('3daa99b0', __exports__)
  }
  
  module.hot.accept("./ds-npot-view.vue?vue&type=template&id=3daa99b0&scoped=true", () => {
    api.rerender('3daa99b0', render)
  })

}


export default __exports__